
import { Vue, Prop, Component, Watch } from 'nuxt-property-decorator';
import InputSelectCountry from '../design-system/input/input-select/InputSelectCountry.vue';

@Component({ components: { InputSelectCountry } })
export default class FormCountryList extends Vue {
  @Prop({ required: true }) value!: string | null;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly labelLess!: boolean;

  innerCountry = '';
  innerStateProvince = '';

  get formattedValue() {
    return this.innerCountry + (this.innerStateProvince ? '/' + this.innerStateProvince : '');
  }

  @Watch('value', { immediate: true })
  onValueChanged() {
    if (this.value) {
      const fieldsOfLocation = this.value.split('/');
      this.innerCountry = fieldsOfLocation[0];
      if (fieldsOfLocation.length === 2) this.innerStateProvince = fieldsOfLocation[1];
    } else {
      this.innerCountry = '';
      this.innerStateProvince = '';
    }
  }

  public onCountryChange(country: string) {
    this.innerCountry = country;
    this.emit();
  }

  public onStateChange(stateProvince: string) {
    this.innerStateProvince = stateProvince;
    this.emit();
  }

  public emit() {
    this.$emit('input', this.formattedValue);
  }
}
